import { Stack } from '@mui/material';
import Text, { Inline } from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import moment from 'moment/moment';

const TooltipWrapper = styled(Flex)`
  background: rgba(255, 255, 255, 0.96);
  border-radius: 5px;
`;
const CellTooltip = ({
  title,
  directionColor,
  previuosValueFormatted,
  trendDirection,
  percentChange,
  lastPeriodDates,
  PreviuosBenchmark
}) => {
  const from = lastPeriodDates?.from;
  const to = lastPeriodDates?.to;

  const lastPeriodDatesFormatted =
    from && to
      ? `(${moment(from).format('MMM DD')} - 
  ${moment(to).format('MMM DD')})`
      : '';

  return (
    <TooltipWrapper direction='column' pt='x-small' pb='x-small'>
      <Text size='medium' color='shuttleGray' weight='800'>
        {title}
      </Text>
      <Text pt='0.8rem' size='medium' color='shuttleGray'>
        <Inline color={directionColor} size='medium' weight='800'>
          {trendDirection}
        </Inline>{' '}
        {percentChange}
      </Text>
      <Stack direction='row' alignItems='center' gap={0.5}>
        <Text size='medium' color='shuttleGray'>
          Previous period:
        </Text>
        <Stack direction='row' alignItems='center' height='2.2rem'>
          <Text size='medium' color='shuttleGray' weight='800'>
            {previuosValueFormatted}
          </Text>
          {PreviuosBenchmark && <PreviuosBenchmark />}
        </Stack>
      </Stack>
      <Text color='shuttleGray'>{lastPeriodDatesFormatted}</Text>
    </TooltipWrapper>
  );
};
export default CellTooltip;
